import { CommonModule } from '@angular/common';
import { NgModule }  from '@angular/core';
import { ClickOutModule } from '../clickout/clickout.module';
import { SelectDropdownComponent } from './select-dropdown.component';


export class SelectDropdownModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [ SelectDropdownComponent ],
  imports: [ CommonModule, ClickOutModule ],
  exports: [ SelectDropdownComponent ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
